import { AsyncActionState } from "@telstra-connect/standard-actions/async-action";

export interface ISortParam {
    sortBy: string;
    sortOrder: string;
}

export interface ITableConfig {
    currentPage: number;
    pageSize?: number; // not required in current flow
}

/**
 * Interface representing the state of incident filters and selections.
 * This includes pagination, search text, selected filters, and selected columns.
 */
export interface ITrackIncidentsList {
    status: AsyncActionState;
    incidentList: unknown[]; // to be implemented
    filters: unknown[]; // to be implemented
    tableConfig: ITableConfig; // to be implemented
    selectedColumns: IncidentColumnKeys;
    searchText: string;
    sortParam: ISortParam;
    selectedFilters: unknown; // to be implemented
    error?: string;
}

/**
 * Enum representing the columns available in the incident table.
 * Each key corresponds to a column name, and its value is the display name.
 */
export enum IncidentTableColumns {
    "priority" = "Priority",
    "incidentId" = "Number",
    "customerReference" = "Your reference",
    "description" = "Brief summary",
    "status" = "Status",
    "displayLocation" = "Location",
    "assignedTo" = "Assigned to",
    "estimatedResolutionDate" = "Estimated resolution",
    "actualResolutionDate" = "Actual resolution",
    "createdBy" = "Raised by"
}

/**
 * Type representing a single key from the IncidentTableColumns enum.
 */
export type IncidentColumnKey = (keyof typeof IncidentTableColumns);

/**
 * Type representing an array of IncidentColumnKey values.
 */
export type IncidentColumnKeys = IncidentColumnKey[];

/**
 * Array of all available column keys.
 * This is derived from the keys of the IncidentTableColumns enum.
 */
export const AllColumnKeys: IncidentColumnKeys =
    Object.keys(IncidentTableColumns) as Array<keyof typeof IncidentTableColumns>;
